import AssetManagementCard from "../components/cards/AssetManagementCard";
import AssetWalletCard from "../components/cards/AssetWalletCard";
import AssetWalletSubgroupCard from "../components/cards/AssetWalletSubgroupCard";
import Container from "../components/Container";
import { useHomeContext } from "../contexts/HomeContext";
import { useAssetSidebarContext } from "../contexts/AssetSidebarContext";
import EmptyWalletState from "../components/EmptyWalletState";

export default function WalletPage() {
    const homeContext = useHomeContext();
    const assetSidebarContext = useAssetSidebarContext();
    
    const hasAnyAsset = (
        (homeContext.fixedIncomeModel?.length ?? 0)
        + (homeContext.variableIncomeModel?.length ?? 0)
        + (homeContext.cashflowModel?.length ?? 0)
        + (homeContext.vehicleModel?.length ?? 0)
        + (homeContext.propertyModel?.length ?? 0)
    ) > 0;
    const isWalletEmpty = !hasAnyAsset && !homeContext.hasProcessingAssets;

    return (
        <>
            {isWalletEmpty && !homeContext.isLoading ? (
                <EmptyWalletState onAddAsset={() => assetSidebarContext.openAssetSidebar()} />
            ) : (
                <Container flexColumn fullWidth gap={3}>
                    <Container wrap gap={2}>
                        <AssetWalletCard />   

                        <AssetWalletSubgroupCard />  
                    </Container>

                    <Container>
                        <AssetManagementCard /> 
                    </Container>
                </Container>
            )}
        </>
    )
}